import angular from 'angular';

import changePasswordComponent from './change-password.component';

export default angular.module('common.components.changePassword', [])
  .component('changePassword', changePasswordComponent)
  .value('EventEmitter', payload => ({ $event: payload }))
  .name;



// WEBPACK FOOTER //
// ./components/app/common/change-password/change-password.module.js